import { NgComponentOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ComponentUtilsService } from '@core/services';
import { customComponentListener, radioConfig } from '@core/types/types';
import { TranslateModule } from '@ngx-translate/core';

export type radioOptionSelected = {
  option: string | number;
};

@Component({
  imports: [TranslateModule, NgComponentOutlet],
  standalone: true,
  selector: 'radio-component',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
})
export class CustomRadioComponent {
  @Input({ required: true }) config!: radioConfig[];
  @Input({ required: false }) listeners!: customComponentListener[];

  @Output() onRadioOptionSelected: EventEmitter<radioOptionSelected> =
    new EventEmitter<radioOptionSelected>();

  protected selectedRadioOption?: string | number;

  @Input()
  set value(val: any) {    
    this.setRadioOptionChecked(val);
  }

  protected defaultConfig = {
    color: 'primary',
    disabled: false,
  };

  constructor(private utils: ComponentUtilsService) {}

  ngOnInit() {
    this.utils.attachListeners(this, this.listeners);

    this.setRadioOptionChecked(this.selectedRadioOption || this.config[0].id);
  }

  setRadioOptionChecked(selectedOption: string | number) {
    this.selectedRadioOption = selectedOption;
    this.onRadioOptionSelected.emit({
      option: selectedOption,
    });
  }
}
